"use client";

import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  AdsCreativesHeader,
  CreativeCard,
  CreativesGridSkeleton,
  CreateAdWithIAModal,
  ViewCreativeModal,
} from "@/feature/ads/cretives";
import { creativesService } from "@/feature/ads/cretives/services/creatives.service";
import type { CreativeItem } from "@/feature/ads/cretives/types/creatives.types";

export default function AdsPage() {
  const [searchParams] = useSearchParams();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewModalIndex, setViewModalIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<CreativeItem[]>([]);

  const productId = searchParams.get("product_id");

  useEffect(() => {
    const loadCreatives = async () => {
      setLoading(true);
      try {
        const data = await creativesService.listByProductId(productId || undefined);
        setItems(data);
      } catch (error) {
        console.error("Error loading creatives:", error);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadCreatives();
  }, [productId]);

  const handleViewCreative = (index: number) => {
    setViewModalIndex(index);
    setIsViewModalOpen(true);
  };

  const renderContent = () => {
    if (loading) {
      return <CreativesGridSkeleton />;
    }

    if (!loading && items.length === 0) {
      return (
        <div className="mt-12 bg-white border border-gray-200 rounded-2xl p-10 text-center">
          <p className="text-gray-700 font-semibold">
            Aún no tienes creativos disponibles.
          </p>
          <p className="text-gray-500 text-sm mt-2">
            Crea un creativo primero y luego vuelve aquí.
          </p>
        </div>
      );
    }

    return (
      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {items.map((item, index) => (
          <CreativeCard
            key={`${item.image_url}-${index}`}
            item={item}
            index={index}
            onClick={() => {
              console.log("Creative clicked:", item.name || item.product_name);
            }}
            onView={handleViewCreative}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen max-w-[90%] mx-auto bg-[#F5F6FA] p-8 font-['Plus_Jakarta_Sans']">
      <AdsCreativesHeader onCreate={() => setIsCreateModalOpen(true)} />
      {renderContent()}

      <CreateAdWithIAModal
        open={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        initialStep={1}
      />

      <ViewCreativeModal
        open={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        creatives={items}
        initialIndex={viewModalIndex}
      />
    </div>
  );
}
